import React, { lazy } from 'react';
const bonuses = [{
  number: 1,
  title: 'Taller Profesional de Sahumerios y Bombas de Humo',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/SAHUMERIOS.png?v=1768338592'
}, {
  number: 2,
  title: 'Producción Experta de Jabones de Glicerina',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/JABONES.png?v=1768338593'
}, {
  number: 3,
  title: 'Producción de Sales de Baño para Emprender',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/SALES_DE_BANO.png?v=1768338592'
}, {
  number: 4,
  title: 'Calendario de Producción por Estación',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/estacion.png?v=1768338882'
}, {
  number: 5,
  title: 'Acabado Cremoso y Profesional en Velas y Wax Melts',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/acabado_cremoso.png?v=1768338592'
}, {
  number: 6,
  title: 'Manual Profesional de Solución a Errores en Velas',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/errores.png?v=1768338592'
}, {
  number: 7,
  title: 'Recetario de Aromas Exclusivos',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/recetario_de_aromas.png?v=1768339783'
}, {
  number: 8,
  title: 'Producción y Escalabilidad en Velas y Wax Melts',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/produccion_y_escalabilidad.png?v=1768338859'
}, {
  number: 9,
  title: 'Lista Premium de Proveedores por Provincia — Argentina',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/proveedores.png?v=1768338882'
}, {
  number: 10,
  title: 'Certificado de Finalización',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/certificado.png?v=1768338775'
}, {
  number: 11,
  title: 'Cómo Combinar Aromas y Colores con Propósitos',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/como_combinar.png?v=1768338858'
}, {
  number: 12,
  title: 'Marketing para Productos Aromáticos',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/marketing.png?v=1768338775'
}, {
  number: 13,
  title: 'Identidad de Marca',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/identidad_de_marca.png?v=1768338881'
}, {
  number: 14,
  title: '20 Aromas Exclusivos de Autor',
  image: 'https://cdn.shopify.com/s/files/1/0645/3598/6275/files/20_aromas.png?v=1768338851'
}];
export function NewBonusSection() {
  return <section className="bg-gradient-to-b from-[#F8F8FA] to-white py-16 md:py-24 px-4" data-id="element-143">
      <div className="container mx-auto max-w-6xl" data-id="element-144">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-145">
          <div className="inline-block px-4 py-2 bg-gradient-to-r from-[#FFD6EC] to-[#FFB3E6] rounded-full mb-4" data-id="element-146">
            <span className="text-sm font-bold text-[#FF4DB8]" data-id="element-147">
              14 BONOS INCLUIDOS
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-148">
            Todo esto es tuyo, gratis
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto" data-id="element-149">
            Recursos adicionales para maximizar tus resultados y escalar tu
            negocio
          </p>
        </div>

        {/* Grid - 4 por fila */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-150">
          {bonuses.map(bonus => <article key={bonus.number} className="backdrop-blur-sm bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden group" data-id="element-151">
              {/* Image */}
              <div className="relative overflow-hidden bg-gradient-to-br from-pink-50 to-purple-50" data-id="element-152">
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-153" />
                {/* Bonus badge */}
                <div className="absolute top-3 left-3" data-id="element-154">
                  <span className="px-3 py-1 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] text-white text-xs font-bold rounded-full shadow-md" data-id="element-155">
                    BONUS #{bonus.number}
                  </span>
                </div>
              </div>

              {/* Title */}
              <div className="p-5" data-id="element-156">
                <h3 className="text-base font-bold text-gray-900 leading-snug" data-id="element-157">
                  {bonus.title}
                </h3>
              </div>
            </article>)}
        </div>

        {/* Bottom callout */}
        <div className="mt-12 backdrop-blur-sm bg-gradient-to-r from-[#FFD6EC]/40 to-[#FFB3E6]/40 rounded-3xl border border-[#FF4DB8]/20 p-8 text-center" data-id="element-158">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-159">
            14 bonos incluidos en tu compra
          </p>
          <p className="text-lg text-[#6B6B6B]" data-id="element-160">
            Todo lo que necesitás para emprender y escalar tu negocio aromático
          </p>
        </div>
      </div>
    </section>;
}